import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

@Injectable({
    providedIn: 'root',
})
export class CsvService {
    constructor(private http: HttpClient) {}
}
